import "./js/mobile-menu";
import "./js/collapsible-menu";
import "./js/header-menu";
import "./js/header-shadow-after-scroll";
// import "./js/form-handler";
// import "./js/recaptcha";
import "./js/language-toggler";
import "./js/textarea-validation";
